import {useSnackbar, type VariantType, type WithSnackbarProps} from 'notistack';
import {type AxiosError} from 'axios';
import {Component, Progress} from './AlertElement';
import {type AppAxiosError} from 'interfaces';

let snackbarRef: WithSnackbarProps;

export const SnackbarUtilsConfigurator = () => {
  snackbarRef = useSnackbar();
  return null;
};

function humanize(str: string) {
  const errorString = JSON.stringify(str);
  return errorString
    .replace(/[\])}[{(]/g, '')
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/['"]+/g, '')
    .replace(/:/g, ': ')
    .replace(/^[a-z]/, function (m) {
      return m.toUpperCase();
    })
    .replace(/([A-Z])/g, ' $1')
    .replace('Json:', '')
    .trim();
}

export const errorMessageHandler = (error: AppAxiosError) => {
  const errorMessage =
    error.response && error.response.data.errors ? humanize(error.response.data.errors) : JSON.stringify(error.message);
  return errorMessage.substring(0, 600);
};

// eslint-disable-next-line
export default {
  success(msg: string) {
    this.toast(msg, 'success');
  },
  warning(msg: string) {
    this.toast(msg, 'warning');
  },
  info(msg: string) {
    this.toast(msg, 'info');
  },
  error(error: AxiosError | string | unknown) {
    let errorMessage: string | undefined;
    if (typeof error === 'object' && error && 'isAxiosError' in error && error.isAxiosError) {
      errorMessage = errorMessageHandler(error as AxiosError<any>);
    } else if (typeof error === 'string') {
      errorMessage = error;
    } else if (error instanceof Error) {
      errorMessage = error.toString();
    }
    if (errorMessage !== undefined) {
      this.toast(errorMessage, 'error');
    }
  },
  progress(msg: string, variant: VariantType = 'default') {
    snackbarRef.enqueueSnackbar(msg, {
      variant,
      action: Component(snackbarRef.closeSnackbar),
      content: Progress(snackbarRef.closeSnackbar, msg),
      persist: true,
    });
  },
  toast(msg: string, variant: VariantType = 'default') {
    if (import.meta.env.NODE_ENV !== 'test') {
      snackbarRef.enqueueSnackbar(msg, {variant, action: Component(snackbarRef.closeSnackbar)});
    }
  },
};
